// @flow
import type { State } from 'types/redux';
import type { IValetDetails } from './IValetDetails';
import { createSelector } from 'reselect';

// Selectors
import { getTypeAndPhoneNumber } from 'store/reducers/user/personInfo/selectors';
import { getTransportationOption } from 'store/reducers/appointment/selectors';
import { getExternalLoanerProvider } from 'store/reducers/dealerSettings/selectors';

// Constants
import { TRANSPORTATION } from 'constants/transportation';
import { DROPOFF_PREFERENCE_OPTIONS } from 'constants/clutchValet';

const { VALET, VALETLOANER, LOANER } = TRANSPORTATION;

export function getValetDetails(state: State): IValetDetails {
  return state.appointment.valetDetails;
}

export const getPickupAddress = createSelector(
  getValetDetails,
  ({ pickupAddress }: { pickupAddress: string }) => pickupAddress
);

export const getDropoffAddress = createSelector(
  getValetDetails,
  ({ dropoffAddress }: { dropoffAddress: string }) => dropoffAddress
);

export const getValetComments = createSelector(
  getValetDetails,
  ({ comments }: { comments: string }) => comments
);

export const getPickupDropoffSame = createSelector(
  getValetDetails,
  ({ dropoffPreference }: { dropoffPreference: string }) =>
    dropoffPreference === DROPOFF_PREFERENCE_OPTIONS.SAME_AS_PICKUP_VALET
);

export const getIsClutchPartialValet = createSelector(
  getValetDetails,
  ({ dropoffPreference }: { dropoffPreference: string }) =>
    dropoffPreference === DROPOFF_PREFERENCE_OPTIONS.CLUTCH_PARTIAL_VALET
);

export const getIsDropoffSpecificAddress = createSelector(
  getValetDetails,
  ({ dropoffPreference }: { dropoffPreference: string }) =>
    dropoffPreference === DROPOFF_PREFERENCE_OPTIONS.ANOTHER_LOCATION_VALET
);

export const getValetObjectDetails = createSelector(
  getValetDetails,
  getTypeAndPhoneNumber,
  getTransportationOption,
  getPickupDropoffSame,
  getIsClutchPartialValet,
  getExternalLoanerProvider,
  (
    {
      pickupAddress,
      dropoffAddress,
      comments
    }: {
      pickupAddress: string,
      dropoffAddress: string,
      comments: string
    },
    typeAndPhoneNumber,
    transportationOption,
    pickupDropoffSame,
    isClutchPartialValet,
    externalLoanerProvider
  ) => {
    // Assuming drop off same as pick up
    let dropoffAddressType = 2;
    let finalDropoffAddress = pickupAddress;

    if (!pickupDropoffSame) {
      if (isClutchPartialValet) {
        dropoffAddressType = 0;
        finalDropoffAddress = null;
      } else {
        dropoffAddressType = 1;
        finalDropoffAddress = dropoffAddress;
      }
    }

    if (
      transportationOption === VALET ||
      transportationOption === VALETLOANER
    ) {
      return {
        pickupAddressType: pickupAddress ? 1 : 0,
        pickupAddress,
        dropoffAddressType,
        dropoffAddress: finalDropoffAddress,
        phoneType: typeAndPhoneNumber ? typeAndPhoneNumber.type : '',
        phoneNo: typeAndPhoneNumber ? typeAndPhoneNumber.digits : '',
        valetComments: comments ? comments : '',
        pickupDropoffSame: isClutchPartialValet ? 0 : pickupDropoffSame
      };
    } else if (externalLoanerProvider && transportationOption === LOANER) {
      return {
        pickupAddressType: 0,
        pickupDropoffSame: 0,
        dropoffAddressType: 1
      };
    } else {
      return null;
    }
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/valetDetails/selectors.js